module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "video-container",
    class: {
      'full-screen': _vm.isFullScreen
    }
  }, [(_vm.wxAndroidFlag) ? _c('div', {
    staticClass: "video-wrap j_video_wrap",
    attrs: {
      "id": _vm.videoId
    }
  }, [(_vm.muted) ? _c('video', {
    staticClass: "j_video video",
    class: {
      'cover-fit': _vm.videoFormat === 'COVER'
    },
    style: ({
      'border-radius': ("" + _vm.radius)
    }),
    attrs: {
      "loop": "loop",
      "autoplay": "",
      "x5-video-player-type": "h5",
      "x-webkit-airplay": "true",
      "x5-playsinline": "true",
      "webkit-playsinline": "true",
      "playsinline": "true",
      "muted": "muted"
    },
    domProps: {
      "muted": true
    },
    on: {
      "click": _vm.toggleContr
    }
  }) : _c('video', {
    staticClass: "j_video video",
    class: {
      'cover-fit': _vm.videoFormat === 'COVER'
    },
    style: ({
      'border-radius': ("" + _vm.radius)
    }),
    attrs: {
      "loop": "loop",
      "autoplay": "",
      "x5-video-player-type": "h5",
      "x-webkit-airplay": "true",
      "x5-playsinline": "true",
      "webkit-playsinline": "true",
      "playsinline": "true"
    },
    on: {
      "click": _vm.toggleContr
    }
  })]) : _c('div', {
    staticClass: "video-wrap j_video_wrap",
    attrs: {
      "id": _vm.videoId
    }
  }, [(_vm.loop && _vm.muted) ? _c('video', {
    staticClass: "j_video video",
    class: {
      'cover-fit': _vm.videoFormat === 'COVER'
    },
    style: ({
      'border-radius': ("" + _vm.radius)
    }),
    attrs: {
      "loop": "loop",
      "autoplay": "",
      "x5-video-player-type": "h5",
      "x-webkit-airplay": "true",
      "x5-playsinline": "true",
      "webkit-playsinline": "true",
      "playsinline": "true",
      "muted": "muted"
    },
    domProps: {
      "muted": true
    },
    on: {
      "click": _vm.toggleContr
    }
  }) : (_vm.loop && !_vm.muted) ? _c('video', {
    staticClass: "j_video video",
    class: {
      'cover-fit': _vm.videoFormat === 'COVER'
    },
    style: ({
      'border-radius': ("" + _vm.radius)
    }),
    attrs: {
      "loop": "loop",
      "autoplay": "",
      "x5-video-player-type": "h5",
      "x-webkit-airplay": "true",
      "x5-playsinline": "true",
      "webkit-playsinline": "true",
      "playsinline": "true"
    },
    on: {
      "click": _vm.toggleContr
    }
  }) : (!_vm.loop && _vm.muted) ? _c('video', {
    staticClass: "j_video video",
    class: {
      'cover-fit': _vm.videoFormat === 'COVER'
    },
    style: ({
      'border-radius': ("" + _vm.radius)
    }),
    attrs: {
      "autoplay": "",
      "x5-video-player-type": "h5",
      "x-webkit-airplay": "true",
      "x5-playsinline": "true",
      "webkit-playsinline": "true",
      "playsinline": "true",
      "muted": "muted"
    },
    domProps: {
      "muted": true
    },
    on: {
      "click": _vm.toggleContr
    }
  }) : (!_vm.loop && !_vm.muted) ? _c('video', {
    staticClass: "j_video video",
    class: {
      'cover-fit': _vm.videoFormat === 'COVER'
    },
    style: ({
      'border-radius': ("" + _vm.radius)
    }),
    attrs: {
      "autoplay": "",
      "x5-video-player-type": "h5",
      "x-webkit-airplay": "true",
      "x5-playsinline": "true",
      "webkit-playsinline": "true",
      "playsinline": "true"
    },
    on: {
      "click": _vm.toggleContr
    }
  }) : _vm._e()]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "poster j_poster"
  }, [_c('img', {
    staticClass: "poster-img j_poster_img",
    attrs: {
      "src": _vm.poster
    },
    on: {
      "load": _vm.posterLoaded
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "play-mask"
  }, [_c('img', {
    staticClass: "play-icon j_play_btn",
    attrs: {
      "src": require("./assets/play.png")
    },
    on: {
      "click": _vm.onPlay
    }
  })])]), _vm._v(" "), (_vm.showControls) ? _c('controller', {
    class: {
      'c-hidden': !_vm.isShowContr
    },
    attrs: {
      "updateTime": _vm.updateTime,
      "duration": _vm.duration,
      "width": _vm.w,
      "wrap": _vm.wrap,
      "mutedD": _vm.muted,
      "controlsFlag": _vm.controls,
      "videoId": _vm.videoId,
      "videoIndex": _vm.videoIndex,
      "totalVideo": _vm.totalVideo,
      "autoplay": _vm.autoplay,
      "loop": _vm.loop
    },
    on: {
      "play": _vm.cPlay,
      "pause": _vm.cPause,
      "jump": _vm.cJump,
      "full": _vm.cFull,
      "exitfull": _vm.cExitFull,
      "mutedA": _vm.cMuted,
      "voice": _vm.cVoice,
      "control-action": _vm.controlAction
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading j_loading"
  }, [_c('div', {
    staticClass: "img-wrap j_loading_img"
  }, [_c('span')])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-232ea048"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./static/components/video/index.vue
// module id = 166
// module chunks = 1 2 3 4 5 6 7 8 9 10 11 13 14 16 17 18 19 20 21 23 25 26 28 29 30 31 32 36 37 40 42 70 74 75